/*
  versionInfo: Shown in footer. Update on final releases.
*/
export const environment = {
  production: false,
  versionInfo: 'v0.0.1',
  appName: 'Farm Environment Plan Audit Tool'
};
